import { CURRENT_PRODUCT_MODE, PRODUCT_MODE_MAP } from '@utils/constants';
function execFor(fn, productList, fallbackFn = null) {
  return (...params) => {
    if (productList.includes(CURRENT_PRODUCT_MODE)) {
      return fn(...params);
    } else if (fallbackFn) {
      return fallbackFn(...params);
    }

    return null;
  };
}

execFor.odp = (fn, fallbackFn = null) => execFor(fn, [PRODUCT_MODE_MAP.ODP], fallbackFn);
execFor.ecoServer = (fn, fallbackFn = null) => execFor(fn, [PRODUCT_MODE_MAP.ECO_SERVER], fallbackFn);

export default execFor;
